import { render, staticRenderFns } from "./SurveyStep.vue?vue&type=template&id=53da2153&scoped=true&"
import script from "./SurveyStep.vue?vue&type=script&lang=js&"
export * from "./SurveyStep.vue?vue&type=script&lang=js&"
import style0 from "./SurveyStep.vue?vue&type=style&index=0&id=53da2153&lang=less&scoped=true&"
import style1 from "./SurveyStep.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53da2153",
  null
  
)

export default component.exports